import { globalStyles } from "@client/shared/constants";

const style = {
  pageTitleWrapper: {
    borderRadius: 2,
  },
  tablePaper: {
    "border-radius": "10px",
  },
  audioHeader: {
    minWidth: "320px!important",
    maxWidth: "320px!important",
  },
  deleteDialog: {
    width: 412,
    height: 64,
  },
  closeIcon: {
    fontSize: 28,
    color: "grey.500",
  },
  colorOrange: {
    ...globalStyles.text.color.warning,
  },
  colorGreen: {
    ...globalStyles.text.color.success,
  },
  colorYellow: {
    color: "rgb(244,215,66)",
  },
  colorRed: {
    ...globalStyles.text.color.error,
  },
  moreIcon: {
    color: "grey.400",
  },

  audioPlayerWrapper: {
    "& audio": {
      border: "1px solid #ccc",
      height: 36,
      borderRadius: 2,
    },
    "& audio::-webkit-media-controls-panel": {
      backgroundColor: "#fff",
    },
  },
  recipientsTooltipWrapper: {
    "& .MuiTooltip-tooltip": {
      overflowY: "auto",
      maxHeight: 248,
    },
  },
  audioExpired: {
    border: '1px solid #ccc',
    borderRadius: 2,
    color: '#ccc',
    background: '#F7F7F7'
  }
};

export default style;
